
<app-loading-spinner *ngIf="loader.active"></app-loading-spinner>
<div *ngIf="isUserLogin">
  <app-sidebar></app-sidebar>

  <main class="main-wrapper">

    <app-header></app-header>
    <app-breadcrumb></app-breadcrumb>

    <div class="page-wrapper">
      @if (!isIframe && authService.credentials) {
        <router-outlet></router-outlet>
        }
    </div>
  </main>
  @if(helperService.createCasePopoupVisible) {
    <app-create-case-popup [sidebar]="helperService.isSidebar" [sidebarExpanded]="!helperService.collapsedSidebar" (onClosePopup)="helperService.createCasePopoupVisible = false"></app-create-case-popup>
  }
</div>
